import { Controller } from "@hotwired/stimulus"

// On the /offline page, dim every tile whose href isn't actually in the
// service worker cache. Without this, tapping an uncached tile silently
// re-renders /offline (because the SW falls back to it on fetch failure),
// which feels like the click did nothing.
//
// Cache lookup runs once on connect — the SW's cache only changes on
// navigation events, and we control all navigation on this page.
export default class extends Controller {
  static targets = [ "tile", "status" ]

  async connect() {
    if (!("caches" in window)) return

    for (const tile of this.tileTargets) {
      const href = tile.getAttribute("href")
      if (!href) continue

      // ignoreSearch: query strings on cached visits would otherwise miss
      //   (e.g., /dashboard?source=cookbook in cache, /dashboard tapped here).
      // ignoreVary: server emits `Vary: Accept, Cookie` via PageCacheControl,
      //   so any cookie change since the cache was populated would cause
      //   a strict match to fail — the page was cached but caches.match
      //   silently said "no" because the Cookie header didn't match. We
      //   only care about "is anything stored at this URL", so ignore Vary.
      const hit = await window.caches.match(href, { ignoreSearch: true, ignoreVary: true })
      if (hit) {
        this.#markAvailable(tile)
      } else {
        this.#markUnavailable(tile)
      }
    }
  }

  #markAvailable(tile) {
    const status = tile.querySelector("[data-offline-tile-target='status']")
    if (status) status.textContent = "Saved"
  }

  #markUnavailable(tile) {
    tile.classList.add("opacity-40", "pointer-events-none")
    tile.setAttribute("aria-disabled", "true")
    const status = tile.querySelector("[data-offline-tile-target='status']")
    if (status) status.textContent = "Not saved"
  }
}
